import './ReferenceCount.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { debounce } from 'lodash';
import { FilterComponent } from './FilterComponent';
import { usePrevious } from '@hooks';
import { Flex, InputNumber } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
export const ReferenceCountFilter = (props) => {
    var _a, _b, _c;
    const { format, id, onChange, value, label } = props;
    const startValue = (value === null || value === void 0 ? void 0 : value[0]) || (value === null || value === void 0 ? void 0 : value[1]) ? 0 : null;
    const endValue = (_a = value === null || value === void 0 ? void 0 : value[1]) !== null && _a !== void 0 ? _a : null;
    const [displayRange, setDisplayRange] = useState([startValue, endValue]);
    const showClearButton = (value === null || value === void 0 ? void 0 : value[0]) || (value === null || value === void 0 ? void 0 : value[1]);
    const previousValue = usePrevious(value);
    useEffect(() => {
        var _a, _b;
        if ((value === null || value === void 0 ? void 0 : value[0]) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue[0]) || (value === null || value === void 0 ? void 0 : value[1]) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue[1])) {
            const start = (_a = value === null || value === void 0 ? void 0 : value[0]) !== null && _a !== void 0 ? _a : null;
            const end = (_b = value === null || value === void 0 ? void 0 : value[1]) !== null && _b !== void 0 ? _b : null;
            setDisplayRange([start, end]);
        }
    }, [previousValue, value]);
    const debouncedOnChange = useMemo(() => debounce((start, end) => {
        setDisplayRange([start, end]);
        onChange({
            [id]: {
                format,
                value: start || end ? [start, end, true] : null
            }
        });
    }, 300, { leading: false }), [format, id, onChange]);
    const handleChangeStart = useCallback((start) => {
        const [, end] = displayRange;
        const validEnd = start && end !== null && start > end ? null : end;
        setDisplayRange([start, end]);
        debouncedOnChange(start, validEnd);
    }, [debouncedOnChange, displayRange]);
    const handleChangeEnd = useCallback((end) => {
        const [start] = displayRange;
        const validStart = start && end !== null && start > end ? null : start;
        setDisplayRange([start, end]);
        debouncedOnChange(validStart, end);
    }, [debouncedOnChange, displayRange]);
    const tagLabelStart = (_b = displayRange[0]) !== null && _b !== void 0 ? _b : 0;
    const tagLabelEnd = ((_c = displayRange[1]) !== null && _c !== void 0 ? _c : 0) > 0 ? ` - ${displayRange[1]}` : '+';
    return (React.createElement(FilterComponent, Object.assign({}, props, { className: 'reference-count-filter', tagProps: {
            label,
            value: showClearButton ? `${tagLabelStart}${tagLabelEnd}` : null
        } }),
        React.createElement(Flex, { align: 'center', gap: 16 },
            COPY_GENERIC.FROM,
            React.createElement(InputNumber, { min: 0, onChange: handleChangeStart, value: displayRange[0] || (displayRange[1] ? 0 : null) }),
            COPY_GENERIC.TO,
            React.createElement(InputNumber, { min: 0, onChange: handleChangeEnd, value: displayRange[1] || null }))));
};
